import React, { useMemo, useState } from "react";
import {
  Breadcrumb,
  Button,
  Row,
  Col,
  Table,
  Tag,
  Tooltip,
  Divider
} from "antd";
import { Link, useNavigate } from "react-router-dom";

import "../../../styles/Main.scss";

const MOCK_REQUESTS = [
  {
    key: "1",
    status: "New",
    raRef: "RA-2025-001",
    customerSite: "Gota Residence Project",
    requestType: "Replacement Request",
    itemsSummary: "Basin Mixer Tap (5 pcs)",
    reasonCode: "QC Reject – Damaged Stock",
    receivedDate: "Today, 10:15 AM",
  },
  {
    key: "2",
    status: "New",
    raRef: "RA-2025-002",
    customerSite: "Central Warehouse",
    requestType: "Return for Credit",
    itemsSummary: "PVC Pipes (Various)",
    reasonCode: "Excess Stock",
    receivedDate: "Today, 09:30 AM",
  },
  {
    key: "3",
    status: "Pending",
    raRef: "RA-2025-003",
    customerSite: "Thaltej Site Store",
    requestType: "Replacement Request",
    itemsSummary: "Cement Bags (50), Basin Mixer Tap (2 pcs)",
    reasonCode: "Transit Damage",
    receivedDate: "Yesterday",
  },
  {
    key: "4",
    status: "New",
    raRef: "RA-2025-004",
    customerSite: "Gota Residence Project",
    requestType: "Return for Credit",
    itemsSummary: "PVC Pipes (20)",
    reasonCode: "Wrong Item Received",
    receivedDate: "Today, 11:00 AM",
  },
];

const SupplierReplacementDasbhoard = () => {
  const navigate = useNavigate();
  const [selectedCard, setSelectedCard] = useState(null);

  const summaryCards = [
    {
      title: "New Return Requests",
      value: 3,
      subtext: "Action Required",
      blockClass: "block-1",
      icon: "stylus_note",
    },
    {
      title: "Pending Replacements",
      value: 5,
      subtext: "Awaiting Shipment",
      blockClass: "block-2",
      icon: "pending",
    },
    {
      title: "Completed Returns (This Month)",
      value: 12,
      subtext: null,
      blockClass: "block-3",
      icon: "check_circle",
    },
  ];

  const filteredData = useMemo(() => {
    if (!selectedCard) return MOCK_REQUESTS;
    // Filter logic can be added here based on selectedCard
    return MOCK_REQUESTS;
  }, [selectedCard]);

  const getStatusTag = (status) => {
    if (status === "New") {
      return <Tag color="red">New</Tag>;
    }
    if (status === "Pending") {
      return <Tag color="orange">Pending</Tag>;
    }
    return <Tag>{status}</Tag>;
  };

  const columns = [
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 100,
      render: (status) => getStatusTag(status),
    },
    {
      title: "Customer RA Ref",
      dataIndex: "raRef",
      key: "raRef",
      width: 140,
    },
    {
      title: "Customer Site",
      dataIndex: "customerSite",
      key: "customerSite",
      width: 200,
    },
    {
      title: "Request Type",
      dataIndex: "requestType",
      key: "requestType",
      width: 180,
    },
    {
      title: "Items Summary",
      dataIndex: "itemsSummary",
      key: "itemsSummary",
      render: (text) => (
        <>{text}</>
      ),
    },
    {
      title: "Reason Code",
      dataIndex: "reasonCode",
      key: "reasonCode",
      width: 200,
    },
    {
      title: "Received Date",
      dataIndex: "receivedDate",
      key: "receivedDate",
      width: 150,
    },
    {
      title: "Action",
      key: "action",
      width: 180,
      render: (_, record) => {
        if (record.status === "New") {
          return (
            <Button
              type="primary"
              size="small"
              className="SaveGradiantBtn"
              onClick={() => {
                navigate("/supplier-acknowledge-return", {
                  state: { ra: record },
                });
              }}
            >
              View &amp; Acknowledge
            </Button>
          );
        }
        if (record.status === "Pending") {
          return (
            <Button
              size="small"
              type="primary"
              className="SaveGradiantBtn"
              onClick={() => {
                // eslint-disable-next-line no-console
                console.log("View Details", record);
              }}
            >
              View Details
            </Button>
          );
        }
        return null;
      },
    },
  ];

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip title="View incoming return and replacement requests">
              <h3>Supplier Return &amp; Replacement Dashboard</h3>
            </Tooltip>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Supplier Portal</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

      <section className="grid-sec tablegridsec">
        <div className="PR-body">
          <section className="widgetblock mb-5">
            <Row gutter={[15]}>
              {summaryCards.map((card, index) => (
                <Col key={index} xs={24} sm={12} md={8} lg={8} xl={8}>
                  <div
                    className={`card mb-5 ${
                      selectedCard === card.title ? "active" : ""
                    }`}
                    onClick={() => setSelectedCard(card.title)}
                  >
                    <div className={`card-block ${card.blockClass}`}>
                      <div className="card-box">
                        <div className="card-title">
                        <div className="card-icon">
                          <span className="material-symbols-outlined">
                            {card.icon}
                          </span>
                        </div>
                        <h3>{card.title}</h3>
                        </div>
                        <div className="card-description">
                          
                          <p>{card.value}</p>
                          {card.subtext && <h6>{card.subtext}</h6>}
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </section>

          
          <Divider orientation="left" plain orientationMargin={0} style={{ marginBottom: 0, alignItems:'flex-start' }}>
                  <div className="returninfo-title">Incoming Return &amp; Replacement Requests</div>
                </Divider>
          <div className="tablewrp" style={{  marginTop: '10px', marginBottom: '16px' }}>
            <Table
              rowKey="key"
              columns={columns}
              dataSource={filteredData}
              pagination={{
                pageSize: 10,
                showSizeChanger: true,
                showTotal: (total) => `Total ${total} records`,
              }}
              scroll={{ x: 1200 }}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default SupplierReplacementDasbhoard;
